import React, { useState } from 'react';
import PropManager from './PropManager';
import InventoryManager from './InventoryManager';
import { Package, Layout } from 'lucide-react';

export default function ConResourcesMain() {
  const [activeTab, setActiveTab] = useState<'inventory' | 'scenes'>('inventory');

  return (
    <div className="h-full flex flex-col space-y-6 animate-in fade-in duration-500">
      <div className="bg-lcars-blue text-black p-3 lg:p-4 rounded-r-full flex flex-col md:flex-row justify-between items-start md:items-center gap-4 shrink-0">
        <div className="flex items-center gap-3 lg:gap-4">
          <Package className="w-6 h-6 lg:w-8 lg:h-8" />
          <div>
            <h1 className="text-xl lg:text-2xl font-bold uppercase tracking-tighter leading-tight">Logistics Management</h1>
            <p className="text-[0.5rem] lg:text-[0.6rem] font-bold uppercase tracking-widest opacity-60">Inventory & Scenes</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 w-full md:w-auto pr-4">
            <button 
                onClick={() => setActiveTab('inventory')}
                className={`flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold uppercase transition-all ${
                  activeTab === 'inventory' ? 'bg-[var(--background)] text-lcars-gold' : 'bg-lcars-gold text-black'
                }`}
            >
                <Package className="w-4 h-4" /> INVENTORY
            </button>
            <button 
                onClick={() => setActiveTab('scenes')}
                className={`flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold uppercase transition-all ${
                  activeTab === 'scenes' ? 'bg-[var(--background)] text-lcars-purple' : 'bg-lcars-purple text-black'
                }`}
            >
                <Layout className="w-4 h-4" /> SCENES
            </button>
        </div>
      </div>
      <div className="flex-1 overflow-auto pr-4 scrollbar-hide">
        {activeTab === 'inventory' && <InventoryManager />}
        {activeTab === 'scenes' && <PropManager />}
      </div>
    </div>
  );
}
